import React, { useCallback } from 'react';

import EmptyState from '../../components/emptyState/EmptyState';

export function withErrorAndNoDataComponents (WrappedComponent) {

	const ReturnedComponent = function (props) {

		const ErrorComponent = useCallback(() => (
			<EmptyState
				icon="cloud-offline-outline"
				message="Something went wrong loading this list"
				hint="Check your connection and pull down to try again."
			/>
		), []);
		const NoDataComponent = useCallback(() => (
			<EmptyState message="Nothing to show here yet" hint="New items will appear here." />
		), []);

		return (
			<WrappedComponent {...props} ErrorComponent={ErrorComponent} NoDataComponent={NoDataComponent} />
		);
	};

	return ReturnedComponent;
}
